<div class="vehicle-full-list-config-container">
    <div class="background"></div>
    <div class="content">
        <div class="btn-close" (click)="close()"></div>
        <div class="inner-content">
            <h1>{{'vehicles-list.param-list' | translate}}</h1>
            <div class="select-all">
                <emq-checkbox [formControl]="$any(selectAllControl)"
                              label="{{'vehicles-list.show-all-columns' | translate}}" [ngValue]="true">
                </emq-checkbox>
            </div>
            <div class="type-items">
                <div class="type-item-group" *ngFor="let indicatorTypeGroup of indicatorTypeGroups;">
                    <div class="type-item" *ngFor="let indicatorType of indicatorTypeGroup">
                        <div class="type-item-elem">
                            <emq-checkbox [formControl]="$any(form.controls[indicatorType].get('Selected')!)"
                                [label]="form.controls[indicatorType].get('Name')?.value!" [ngValue]="true">
                            </emq-checkbox>

                            <div class="type-item-elem-mover">
                                <div class="up" (click)="moveUp(form.controls[indicatorType])"
                                    *ngIf="!form.controls[indicatorType]?.get('First')!.value"></div>
                                <div class="down" (click)="moveDown(form.controls[indicatorType])"
                                    *ngIf="!form.controls[indicatorType]?.get('Last')!.value"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
